import React, { useEffect, useState, useRef } from 'react';
import { Spinner, CollapseBlock } from '../../../../common';
import ArticlesTable from './ArticlesTable.jsx';
import { routes } from '../../../../../utils/helpers/ApiClient';
import { AppBarCMS } from '../../../../basic';
import { useTranslation } from 'react-i18next';
import {
  useGetArticlesQuery,
  useDeleteArticleMutation,
  useGetArticleQuery,
} from '../../../../../redux/services/articles.jsx';
import { useNavigate } from 'react-router-dom';
import { useToastMessages } from '../../../../../hooks/useToastMessages';
import { isNull } from 'lodash';
import NewsModal from '../../../PublicPages/HomePage/NewsDetail/NewsItem/NewsModal/NewsModal.jsx';
import dayjs from 'dayjs';

const ArticlePage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const languageType = useRef(null);

  const { data: articles, isLoading, refetch } = useGetArticlesQuery();

  useEffect(() => {
    document.title = t('Články') + ' - FRI CMS';
  }, []); // Runs on mount

  const [deletePage, { isSuccess: isDeleteSuccess }] =
    useDeleteArticleMutation();

  const { deleteSuccess: showDeleteSuccess } = useToastMessages();

  const [pageInPreviewId, setPageInPreviewId] = useState(null);

  const { data: pagePreviewDetail, isFetching: isLoadingPagePreview } =
    useGetArticleQuery(
      { id: pageInPreviewId, isEdit: true },
      { skip: isNull(pageInPreviewId) },
    );

  useEffect(() => {
    if (isDeleteSuccess) {
      showDeleteSuccess();
      refetch();
    }
  }, [isDeleteSuccess]);

  return isLoading ? (
    <Spinner />
  ) : (
    <>
      <AppBarCMS
        title={t('Články')}
        backUrl={routes.cmsDashboard}
        backUrlTooltip={t('Nástenka')}
        createText={t('Pridať článok')}
        createUrl={routes.cmsArticleCreate}
        permissionsBasic={'articles'}
      />
      <div style={{ margin: '10px' }}>
        <CollapseBlock>
          <ArticlesTable
            articles={articles}
            onDelete={(record) => deletePage(record.id)}
            onRowClick={(record) =>
              navigate(`${routes.cmsArticleEdit}/${record.id}`)
            }
            onPreviewClick={(record, type) => {
              setPageInPreviewId(record.id);
              languageType.current = type
                ? type
                : record.title_sk
                  ? 'sk'
                  : 'en';
            }}
          />
        </CollapseBlock>
      </div>

      {!isNull(pageInPreviewId) && (
        <NewsModal
          isLoading={isLoadingPagePreview}
          visible={!isNull(pageInPreviewId)}
          toggleModal={() => setPageInPreviewId(null)}
          content={pagePreviewDetail?.[`content_${languageType.current}`]}
          title={pagePreviewDetail?.[`title_${languageType.current}`]}
          dateOfCreate={dayjs(pagePreviewDetail?.es_date || new Date()).format(
            'D.MM.YYYY h:mm',
          )}
          creatorName={pagePreviewDetail?.creatorName}
        />
      )}
    </>
  );
};

export default ArticlePage;
